import Vue from 'vue';
import i18next from 'i18next';
import Debug from '@/util/debug';
import VueI18Next from '@panter/vue-i18next';
import createInterpolation from './i18n-interpolation';
import { LOCALE_DEFAULT, LOCALE_FALLBACK } from './constants';

const localeRequireContext = require.context('@/locales', false, /\.ya?ml$/);

const getLocales = context => context
  .keys()
  .map(file => {
    const [, localeCode] = file.match(/([a-z]+)\.ya?ml$/) || [];
    if (!localeCode) {
      return null;
    }

    return {
      code: localeCode,
      file: context(file),
    };
  })
  .filter(v => v)
  .reduce((res, curr) => Object.assign(res, { [curr.code]: { translation: curr.file } }), {});

i18next.init({
  fallbackLng: LOCALE_FALLBACK,
  lng: LOCALE_DEFAULT,
  resources: getLocales(localeRequireContext),
  interpolation: {
    format: createInterpolation(i18next.t.bind(i18next)),
    escape: val => val, // disable interpolation result escaping
  },
});

const missingTranslation = Debug('missing-translation');
let reportedMissing = [];
i18next.on('missingKey', (lngs, namespace, key) => {
  const lngArray = Array.isArray(lngs) ? lngs : [lngs];
  lngArray.forEach(lng => {
    const message = `lng: ${lng}, ${namespace}::${key}`;
    if (reportedMissing.indexOf(message) === -1) {
      reportedMissing.push(message);
      missingTranslation.warn(message);
    }
  });
});

Vue.use(VueI18Next);

if (module.hot) {
  module.hot.accept(localeRequireContext, () => {
    const newLocaleRequireContext = require.context('@/locales', false, /\.ya?ml$/);
    i18next.addResources(getLocales(newLocaleRequireContext));
    reportedMissing = [];
  });
}

export default new VueI18Next(i18next);



// WEBPACK FOOTER //
// ./src/util/i18n.js